<app-search-ui></app-search-ui>

<nb-card *ngIf="!customersData || isLoading">
    <nb-card-header>
        Fetching User Data
    </nb-card-header>
    <nb-card-body>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </nb-card-body>
</nb-card>

<nb-card *ngIf="customersData && !isLoading" class="summary-infoCard">
    <nb-card-header style="display: flex; justify-content: space-between;
    align-items: center;">
        <div style="width: 85%;">
            <nb-user size="giant" [name]="customersData['fullName']" [picture]="customersData['profilePicUrl']" (click)="showToast(1000, 'copied',
            customersData['fullName'])" [cdkCopyToClipboard]="customersData['fullName']" nbPopover="Click to
            Copy" nbPopoverTrigger="hover" nbPopoverPlacement="bottom">
            </nb-user>
        </div>
        <div style="display: flex; justify-content: space-evenly; width: 15%">
            <img width="25px" height="25px" nbTooltip="{{getAndroidTooltip()}}" nbTooltipStatus="primary" nbButton status="primary" *ngIf="containsAndroid()" src="../../../assets/icons/android_icon.svg" alt="ANDROID">
            <img width="25px" height="25px" nbTooltip="{{getIOSTooltip()}}" nbTooltipStatus="primary" nbButton status="primary" *ngIf="containsIOS()" src="../../../assets/icons/ios_icon.svg" alt="IOS">
        </div>
        <div>
            <nb-icon icon="more-vertical-outline" [nbContextMenu]="items" nbContextMenuTag="profile-menu-tag"></nb-icon>
        </div>
    </nb-card-header>
    <nb-card-body>
        <div class="summary-container">
            <div *ngIf="customersData['emailId']">
                <div>Email</div>
                <div class="h6" style="text-align: left ;" (click)="showToast(1000,
          'copied', customersData['emailId'])" [cdkCopyToClipboard]="customersData['emailId']" nbPopover="Click to
          Copy" nbPopoverTrigger="hover" nbPopoverPlacement="bottom">{{customersData['emailId']}}</div>
            </div>
            <div *ngIf="false">
                <div>Auth Provider</div>
                <div class="h6">{{customersData['authProvider']}}</div>
            </div>
            <div *ngIf="customersData['mobile']">
                <div>Mobile</div>
                <div class="h6" (click)="showToast(1000, 'copied',
          customersData['mobile'])" [cdkCopyToClipboard]="customersData['mobile']" nbPopover="Click to
          Copy" nbPopoverTrigger="hover" nbPopoverPlacement="bottom">{{customersData['mobile']}}</div>
            </div>
            <div>
                <div>SignedUp Time </div>
                <div class="h6">{{customersData['createdAt']| date:'medium'}}
                </div>
            </div>
            <div>
                <div style="height: 32px;">Verified</div>
                <nb-icon *ngIf="customersData['isVerified']" icon="checkmark-circle-2-outline" status="success"></nb-icon>
                <nb-icon *ngIf="!customersData['isVerified']" icon="close-circle-outline" status="danger"></nb-icon>
                <!-- <div class="h6">{{customersData['isVerified']}}</div> -->
            </div>
            <div>
                <div>
                    <img src="../../../assets/google_assistant_icon.png" style="width:
            32px; height: 32px;" alt="" srcset="">
                </div>
                <nb-icon *ngIf="customersData['isGoogleAssistantLinked']" icon="checkmark-circle-2-outline" status="success">
                </nb-icon>
                <nb-icon *ngIf="!customersData['isGoogleAssistantLinked']" icon="close-circle-outline" status="danger">
                </nb-icon>
                <!-- <div class="h6">{{ customersData['isGoogleAssistantLinked'] ? "Linked" : "Not Linked"}}</div> -->
            </div>
            <div>
                <div><img src="../../../assets/alexa_icon.png" style="width: 32px;
            height: 32px;" alt="" srcset=""></div>
                <nb-icon *ngIf="customersData['isAlexaLinked']" icon="checkmark-circle-2-outline" status="success"></nb-icon>
                <nb-icon *ngIf="!customersData['isAlexaLinked']" icon="close-circle-outline" status="danger"></nb-icon>
                <!-- <div class="h6">{{customersData['isAlexaLinked'] ? "Linked" : "Not Linked"}}</div> -->
            </div>
        </div>
        <!-- <div class="showlocalEngagementSection">
      <nb-toggle labelPosition="start" [(ngModel)]="showlocalEngagement">Show user engagement data
      </nb-toggle>
    </div> -->
        <nb-accordion *ngIf="customersData['warrantyInfo']">
            <nb-accordion-item>
                <nb-accordion-item-header>Warranty Information</nb-accordion-item-header>
                <nb-accordion-item-body>
                    <div>
                        <span>Name : </span> <b>{{customersData["warrantyInfo"].name}}</b><br>
                        <span>Email : </span> <b>{{customersData["warrantyInfo"].email}}</b><br>
                        <span>Mobile : </span> <b>{{customersData["warrantyInfo"].phoneNumber}}</b><br>
                        <span>Updated At : </span> <b>{{customersData["warrantyInfo"].createdAt
              |
              date:'medium'}}</b>
                    </div>
                </nb-accordion-item-body>
            </nb-accordion-item>
        </nb-accordion>
        <br>
        <nb-accordion *ngIf="customersData['previousContacts'] && customersData['previousContacts'].length">
            <nb-accordion-item>
                <nb-accordion-item-header>Previous Contacts</nb-accordion-item-header>
                <nb-accordion-item-body>
                    <div style="padding: 20px;">
                        <nb-list>
                            <nb-list-item *ngFor="let entry of customersData['previousContacts']">
                                <span>Unlinked <b>{{entry.contact}}</b> at <b>{{entry.createdAt | date:'medium'}}</b></span>
                            </nb-list-item>
                        </nb-list>
                    </div>
                </nb-accordion-item-body>
            </nb-accordion-item>
        </nb-accordion>

        <div class="summary-container" *ngIf="showlocalEngagement">


            <nb-select [(selected)]="selectedComparePeriod">
                <nb-select-label>
                    {{ selectedComparePeriod }}
                </nb-select-label>
                <nb-option value="Daily">Daily</nb-option>
                <nb-option value="Weekly">Weekly</nb-option>
                <nb-option value="Fortnightly">Fortnightly</nb-option>
                <nb-option value="Monthly">Monthly</nb-option>
                <nb-option value="Quarterly">Quarterly</nb-option>
                <nb-option value="Yearly">Yearly</nb-option>
            </nb-select>
            <nb-card>
                <nb-card-body>

                    <table [nbTreeGrid]="dataSource" [nbSort]="dataSource" equalColumnsWidth>

                        <tr nbTreeGridHeaderRow *nbTreeGridHeaderRowDef="allColumns"></tr>
                        <tr nbTreeGridRow *nbTreeGridRowDef="let row; columns: allColumns"></tr>
                        <ng-container [nbTreeGridColumnDef]="customColumn">

                            <th nbTreeGridHeaderCell *nbTreeGridHeaderCellDef nbSortHeader>
                                {{customColumn}}
                                <span *nbSortHeaderIcon="let asc= isAscending; let desc=
                  isDescending">
                  <span *ngIf="asc" class="nb-chevron-down" aria-label="sorted
                    ascending"></span>
                                <span *ngIf="desc" class="nb-chevron-up" aria-label="sorted
                    descending"></span>
                                </span>
                            </th>

                            <td nbTreeGridCell *nbTreeGridCellDef="let row">
                                <button nbTreeGridRowToggle *ngIf="row.hasChildren()" [attr.aria-label]="row.expanded ? 'collapse' : 'expand'">
                  <span [ngClass]="{'nb-chevron-down': row.expanded,
                    'nb-chevron-right': !row.expanded}"
                    aria-hidden="true">
                  </span>
                </button> {{row.data.name}}
                            </td>

                        </ng-container>

                        <ng-container *ngFor="let column of defaultColumns" [nbTreeGridColumnDef]="column">
                            <th nbTreeGridHeaderCell *nbTreeGridHeaderCellDef>{{column}}</th>
                            <td nbTreeGridCell *nbTreeGridCellDef="let row">{{row.data[column]}}</td>
                        </ng-container>

                    </table>

                </nb-card-body>
            </nb-card>
        </div>
        <div class="summary-container" *ngIf="summary.length>0">
            <div *ngFor="let item of summary">
                <div>{{ item.title }}</div>
                <div class="h6">{{ item.value }}</div>
            </div>
        </div>
    </nb-card-body>
</nb-card>

<div fxLayout="row" fxLayoutAlign="end end" style="margin-bottom: 20px;"  *ngIf="customersData && customersData['hubs'] &&
  customersData['hubs'].length && !isLoading && linkedDevices.yale.length">
    <button nbButton outline status="info" (click)="scrollToLinkedDevices()">
        Jump To Linked Devices
    </button>
</div>

<div fxLayout="row" fxLayoutAlign="end end" style="margin-bottom: 20px;" *ngIf="customersData && customersData['hubs'] &&
customersData['hubs'].length && !isLoading">
    <nb-form-field>
        <input type="text" nbInput placeholder="Search eID" [(ngModel)]="searchEid" (ngModelChange)="onSearchEidInput($event)">
        <button nbSuffix nbButton ghost (click)="clearSearchEid()" *ngIf="searchEid.length">
          <nb-icon icon="close-circle-outline"
                   pack="eva">
          </nb-icon>
        </button>
    </nb-form-field>
    <b *ngIf="isSearchingByEid" style="margin-left: 10px;margin-bottom: 10px;">Found {{showingResultCount}} {{showingResultCount <= 1 ? "Device" : "Devices"}}</b>
</div>

<!-- {{customersData['hubs']}} -->
<div fxLayout="row" fxLayoutAlign="space-between center" style="margin-bottom: 20px;">
    <h6>HUBS</h6>
    <nb-toggle labelPosition="start" [(checked)]="onlyOwned" (change)="onToggle()">Show Only Owned Hubs</nb-toggle>
</div>
<div *ngIf="customersData && customersData['hubs'] &&
  customersData['hubs'].length && !isLoading">

    <nb-card class="hub-infoCard" *ngFor="let hub of customersData['hubs']; index
    as i">
        <nb-card-header *ngIf="hub['hubStatus'] &&
      hub['hubStatus']['blockFunctionality']" style="background-color: rgb(233, 53, 53); color: white;">
            Locked Hub and Functionality - {{hub['hubStatus']['reason']}} - ({{hub['hubStatus']['modifiedBy']}} - {{hub['hubStatus']['updatedAt'] | date:'medium' }})
        </nb-card-header>
        <nb-card-header *ngIf="hub['hubStatus'] && hub['hubStatus']['status'] ==
      'LOCKED'" style="background-color: rgb(245, 172, 104); color: white;">
            Locked Hub - {{hub['hubStatus']['reason']}} - {{hub['hubStatus']['modifiedBy']}} - ({{hub['hubStatus']['updatedAt'] | date:'medium' }})
        </nb-card-header>
        <nb-card-body>
            <div class="hub-header">
                <div class="hub-title">
                    <span class="h6"> HUB
            <span *ngIf="hub.variant && hub.variant == 257"> Lite </span>
            <span *ngIf="hub.type == 126"> Plus </span>
            <span *ngIf="(hub.ipType && hub.ipType == 2) || hub.type == 125"> Pro </span> : {{hub.shortId}} <span *ngIf="hub.pDataAccessible && hub.pData[hub.hubId+ ':0:0']">({{hub.pData[hub.hubId+ ':0:0'].name}})</span> <span *ngIf="hub.isOnline" nbPopover="Online" nbPopoverTrigger="hover" nbPopoverPlacement="bottom">
              <nb-icon icon="globe" status="success"></nb-icon>
            </span> <span *ngIf="!hub.isOnline" nbPopover="Offline" nbPopoverTrigger="hover" nbPopoverPlacement="bottom">
              <nb-icon icon="globe" status="danger"></nb-icon>
            </span> <span *ngIf="hub.isSharedHub"> (Shared Hub -
              {{hub.ownerInfo}}) </span>
                    </span>
                    <span class="h6 kitType" *ngIf="hub.configInfo &&
                    hub.configInfo.kitType">
                    {{(hub.configInfo.kitType).replaceAll("_", " ")}}
                        <nb-icon icon="stop-circle-outline"></nb-icon>
                    </span>
                    <span class="h6 kitType" *ngIf="!hub.configInfo &&
                    hub.preConfigTarget">
                    {{(hub.preConfigTarget).replaceAll("_", " ")}}
                        <nb-icon icon="stop-circle-outline"></nb-icon>
                    </span>
                </div>
                <div style="min-width: 450px;margin-top: -10px;margin-right: 20px;" fxLayout="row" fxLayoutAlign="end center">
                                    <nb-toggle status="primary" [(ngModel)]="hub.autoRefreshStatus" (checkedChange)="autoRefreshStatusToggleChanged(hub,i)">Auto Refresh</nb-toggle>
                                    <span style="margin-left: 10px;margin-right: 10px;" *ngIf="hub.autoRefreshStatus">in</span>
                                    <nb-select [(selected)]="hub.autoRefreshStatusTime" *ngIf="hub.autoRefreshStatus" (selectedChange)="autoRefreshStatusTimeChanged(hub,i)">
                                        <nb-option value="5">5s</nb-option>
                                        <nb-option value="10">10s</nb-option>
                                        <nb-option value="20">20s</nb-option>
                                    </nb-select>
                </div>
                <div class="hub-options">
                    <nb-icon icon="more-vertical-outline" [nbContextMenu]="hubSpecificMenu" [nbContextMenuTag]="[hub.hubId,hub.placeId]"></nb-icon>
                    <nb-icon mat-raised-button (click)="openHubHistoryDialog(hub.hubId)" icon="clock-outline"></nb-icon>
                </div>
            </div>


            <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="32px" fxLayoutAlign="flex-start">
                <div class="hub-summary">
                    <div> eID </div>
                    <div class="h6">
                        <span (click)="showToast(1000, 'copied', hub.hubId)" [cdkCopyToClipboard]="hub.hubId" nbPopover="Click to Copy" nbPopoverTrigger="hover" nbPopoverPlacement="bottom">{{hub.hubId}}</span> |
                        <span (click)="showToast(1000, 'copied', hub.hubId.split('-').join('
              '))" [cdkCopyToClipboard]="hub.hubId.split('-').join(' ')" nbPopover="Click to Copy" nbPopoverTrigger="hover" nbPopoverPlacement="bottom">{{hub.hubId.split("-").join(" ")}}</span>
                    </div>
                </div>

                <div class="hub-summary">
                    <div>nodes </div>
                    <div class="h6">{{hub.nodeCount}}</div>
                </div>

                <div class="hub-summary">
                    <div> Scenes </div>
                    <div class="h6">
                        <nb-icon icon="grid"></nb-icon>
                        {{hub.hiddenSceneSize}} Hidden, {{hub.deletedSceneSize}} Deleted, {{hub.nonDeletedSceneSize}} Active,{{hub.nonSyncedSceneSize}} Not Synced
                    </div>
                </div>

                <div class="hub-summary">
                    <div> Rules </div>
                    <div class="h6">
                        <nb-icon icon="npm"></nb-icon>
                        {{hub.iftttSize?hub.iftttSize:"0"}}
                    </div>
                </div>

                <div class="hub-summary">
                    <div> SSID </div>
                    <div class="h6">
                        <nb-icon icon="wifi-outline"></nb-icon> {{hub.ssid}}
                    </div>
                </div>

                <div class="hub-summary" *ngIf="hub.secondarySsid">
                    <div>Secondary SSID </div>
                    <div class="h6">
                        <nb-icon icon="wifi"></nb-icon> {{hub.secondarySsid}}
                    </div>
                </div>

                <div class="hub-summary" *ngIf="hub.connectedSsidSlot!=null">
                    <div>Connected Slot </div>
                    <div class="h6">
                        <nb-icon icon="pricetags"></nb-icon> {{hub.connectedSsidSlot}}
                    </div>
                </div>

                <div class="hub-summary">
                    <div> WiFi Mac </div>
                    <div class="h6">{{hub.wifiMac}}</div>
                </div>

                <div class="hub-summary">
                    <div> Last Known IP </div>
                    <div class="h6">{{hub.lastKnownIp}}</div>
                </div>

                <div class="hub-summary">
                    <div> Last Known Port </div>
                    <div class="h6">{{hub.lastKnownPort}}</div>
                </div>

                <div class="hub-summary">
                    <div> FW Version </div>
                    <div class="h6">{{hub.firmwareVersion}}</div>
                </div>
                <div class="hub-summary">
                    <div> Hardware Version </div>
                    <div class="h6">{{hub.productV == undefined ? "N/A" : hub.productV}}</div>
                </div>

                <div class="hub-summary">
                    <div> Region </div>
                    <div class="h6">{{hub.region}}</div>
                </div>
                <div class="hub-summary">
                    <div> Variant </div>
                    <div class="h6">{{hub.variant}}</div>
                </div>

                <div class="hub-summary" *ngIf="hub.createdAt">
                    <div> Commissioned At </div>
                    <div class="h6">{{hub.createdAt | date:'medium'}}</div>
                </div>
                <div class="hub-summary" *ngIf="hub.warrantyExpiryAt">
                                        <div> Warranty Expiry At</div>
                                        <div class="h6">
                                            {{hub.warrantyExpiryAt}}
                                        </div>
                </div>
                <!-- <div class="hub-summary">
          <div> Voltage </div>
          <div class="h6">
            <nb-icon icon="activity-outline"></nb-icon> {{hub.voltage?hub.voltage.toFixed(3):"N/A"}}
          </div>
        </div> -->
                <div class="hub-summary">
                    <div> Temperature </div>
                    <div class="h6">
                        <nb-icon icon="thermometer-outline"></nb-icon>
                        {{hub.temperature?hub.temperature:"N/A"}}
                    </div>
                </div>

                <div class="hub-summary">
                    <div> RSSi </div>
                    <div class="h6">
                        <nb-icon icon="radio-outline" [status]="getHubRssiWarningLevel(hub.rssi)"></nb-icon>
                        {{hub.rssi?hub.rssi+110:"N/A"}}
                    </div>
                </div>
                <div class="hub-summary">
                    <div> Range Mode </div>
                    <div class="h6">
                        <div class="h6">{{hub.rangeMode == undefined ? "N/A" : hub.rangeMode}}</div>    
                    </div>
                    <div fxLayout="row" *ngIf="hub.rangeMode" style="margin-top: 5px;" fxLayoutAlign="space-evenly">
                        <button *ngIf="hub.rangeMode == 'LONG_RANGE'" nbTooltip="Change HUB Range to Short" nbButton size="tiny" (click)="changeHubRange('02',hub.hubId)">Short</button>
                        <button *ngIf="hub.rangeMode == 'NORMAL_RANGE'" nbTooltip="Change HUB Range to Long" nbButton size="tiny" (click)="changeHubRange('01',hub.hubId)">Long</button>
                    </div>
                </div>
                <div class="hub-summary">
                    <div> Capability Version </div>
                    <div class="h6">
                        <div class="h6">{{hub.applicationCapability == undefined ? "" : hub.applicationCapability}}</div>    
                    </div>                    
                </div>

                <div class="hub-summary">
                    <div> Place </div>
                    <div class="h6">
                        <span (click)="showToast(1000, 'copied', hub.placeName)" [cdkCopyToClipboard]="hub.placeName" nbPopover="Click to Copy" nbPopoverTrigger="hover" nbPopoverPlacement="bottom">{{hub.placeName}}</span> | <span (click)="showToast(1000, 'copied', hub.placeId)"
                            [cdkCopyToClipboard]="hub.placeId" nbPopover="Click to Copy" nbPopoverTrigger="hover" nbPopoverPlacement="bottom">{{hub.placeId}}</span> | <span (click)="showToast(1000, 'copied', hub.placeTimeZone)"
                            [cdkCopyToClipboard]="hub.placeTimeZone" nbPopover="Click to Copy" nbPopoverTrigger="hover" nbPopoverPlacement="bottom">{{hub.placeTimeZone}}</span>
                    </div>
                </div>

                <div style="width: 100%;">
                    <p style="float:right; " *ngIf="hub.capturedAt" nbPopover="Last Health
            Update from the Device." nbPopoverTrigger="hover" nbPopoverPlacement="bottom"> Last Update: {{hub.capturedAt | date:'medium' }}
                    </p>
                </div>

            </div>

            <div class="showlocalEngagementSection">
                <nb-card>
                    <nb-card-body>
                        <div fxLayout="row" fxLayoutAlign="space-evenly center">
                            <b>Health Graph :</b>
                            <input [nbDatepicker]="datepickerHubStart" nbInput placeholder="Start Date" [(ngModel)]="hub.graphStart">
                            <nb-datepicker #datepickerHubStart></nb-datepicker>
                            <b>-</b>
                            <input [nbDatepicker]="datepickerHubEnd" nbInput placeholder="End Date" [(ngModel)]="hub.graphEnd">
                            <nb-datepicker #datepickerHubEnd></nb-datepicker>
                            <nb-checkbox style="margin-left: 20px;" (checkedChange)="showAllHealthDataChangeHub($event,hub)">Show All Points</nb-checkbox>
                            <button nbButton status="info" (click)="fetchHealthGraph(hub.hubId,
                        'Hub', hub.showHealthGraph,hub.showAllHealthData,hub)">Get Health Data</button>
                        </div>
                        <plotly-plot style="width: 100%;"  *ngIf="graph[hub.hubId] && hub.showHealthGraph" [data]="graph[hub.hubId].data" [layout]="graph[hub.hubId].layout">
                        </plotly-plot>
                    </nb-card-body>
                </nb-card>
                <br>
                <br>
                <nb-toggle labelPosition="start" (click)="fetchRepeaterGraph(hub.hubId,
          hub.showRepeaterGraph)" [(ngModel)]="hub.showRepeaterGraph" style="margin-bottom: 10px;">
                    Show Repeater Graph
                </nb-toggle>
                <nb-card>
                    <nb-card-body *ngIf="hub.showRepeaterGraph">
                        <button style="float: right;" mat-mini-fab aria-label="refresh-icon" (click)="fetchRepeaterGraph(hub.hubId, false)">
              <!-- <mat-icon>home</mat-icon> -->
              <nb-icon icon="refresh-outline"></nb-icon>
            </button>
                        <mat-spinner *ngIf="!repeaterGraph.data[hub.hubId]"></mat-spinner>
                        <google-chart *ngIf="repeaterGraph.data[hub.hubId]" style="width:
              400px; height: 300px;" [options]="{allowHtml:true}" [type]="'OrgChart'" [columns]="repeaterGraph.data[hub.hubId]['cols']" [data]="repeaterGraph.data[hub.hubId]['rows']"></google-chart>
                        <!-- <plotly-plot *ngIf="graph[hub.hubId]" [data]="graph[hub.hubId].data" [layout]="graph[hub.hubId].layout"></plotly-plot> -->
                    </nb-card-body>
                </nb-card>
            </div>
            <nb-accordion class="info-section">
                <nb-accordion-item>
                    <nb-accordion-item-header>Debugger</nb-accordion-item-header>
                    <nb-accordion-item-body>
                        <nb-card class="inline-form-card">
                            <nb-card-body>
                                <form (submit)='sendCommand(debuggerForm, hub.hubId)' #debuggerForm="ngForm">
                                    <mat-form-field style="width: 100%">
                                        <input class="block" matInput type="text" name="command" ngModel required text placeholder="Command" #commandInput="ngModel">
                                        <mat-error *ngIf="commandInput.invalid">"please enter valid command"
                                        </mat-error>
                                    </mat-form-field>
                                    <button mat-raised-button color="accent" type="submit">Send</button>
                                </form>

                            </nb-card-body>
                        </nb-card>
                    </nb-accordion-item-body>
                </nb-accordion-item>
            </nb-accordion>
            <nb-accordion class="info-section">
                <nb-accordion-item>
                    <nb-accordion-item-header class="no-arrow" (click)="ngAccordingHeaderClicked($event,'showNodes',hub)">
                        <div fxLaout="row" style="width: 100%;" fxLayoutAlign="space-between center">
                            <b style="display: inline;">Nodes</b>
                            <!-- <nb-toggle class="custom-toggle checked" labelPosition="start" [(checked)]="hub.showNodes" style="z-index: 999;"></nb-toggle> -->
                        </div>
                    </nb-accordion-item-header>
                    <nb-accordion-item-body *ngIf="hub.showNodes">
                        <nb-card>
                            <nb-card-body>
                                <div class="node-list-header">
                                    <div class="device-btn-shared">
                                        <h6 class="md-padding">Select node by name</h6>
                                        <div *ngIf="hub.pDataAccessible">
                                            <nb-select class="md-padding" [ngModel]="value" (ngModelChange)="scroll($event)" placeholder="Select node app">
                                                <nb-option *ngFor="let option of hub.pData | keyvalue" [value]="option.value.hubId + ':' +
                          option.value.nodeId">
                                                    {{option.value.name + '(' + option.value.nodeId + ', ' + option.value.appId + ')'}}</nb-option>
                                            </nb-select>
                                            <!-- <button nbButton class="md-padding" > -->
                                            <!-- <span>
                          <nb-icon nbPopover="Click to enable." nbPopoverTrigger="hover" icon="lock-outline" status="danger"></nb-icon>Device names disbled.
                        </span>
                        <span>
                          <nb-icon nbPopover="Click to disable." nbPopoverTrigger="hover" icon="unlock-outline" status="info"></nb-icon>Device names enabled.
                        </span> -->
                                            <!-- </button> -->
                                        </div>
                                        <div *ngIf="!hub.pDataAccessible">
                                            <button nbButton outline (click)="openDialog()">
                        <nb-icon icon="lock-outline" status="danger"></nb-icon>Enable
                        device names.
                      </button>
                                        </div>
                                    </div>
                                    <!-- search tool for nodes -->
                                    <div class="node-search-tool">
                                        <div class="search-field">
                                            <nb-form-field>
                                                <input type="text" [(ngModel)]="searchData[hub.hubId]['searchString']" placeholder="search nodes" nbInput (ngModelChange)="onSearchEidInputSmall($event,hub)">
                                                <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
                                            </nb-form-field>
                                        </div>
                                        <div>
                                            <button nbButton size="small" status="primary" (click)="clearFields(hub.hubId,hub)">Clear</button>
                                        </div>
                                    </div>
                                    <!-- search tool for nodes -->
                                </div>
                            </nb-card-body>
                        </nb-card>

                        <!-- added filter pipe for searching nodes -->
                        <nb-card *ngFor="let node of hub['nodes']" class="summary-infoCard">
                            <nb-card-body #node id="{{hub.hubId + ':' + node.shortAddress}}">
                                <div class="node-header">
                                    <div>
                                        <span class="subtitle">Node Id: {{node.shortAddress}}
                      <nb-icon *ngIf="node.isRepeaterNode" icon="shake-outline"
                        status="info" nbButton
                        nbPopover="Repeater Node" nbPopoverTrigger="hover"
                        nbPopoverPlacement="bottom">
                      </nb-icon>
                      <span *ngIf="node.isRepeaterNode">{{getHumanRepeaterNo(node.repeaterNo)}}</span>
                    </span>
                                    </div>
                                    <div>
                                        <span *ngIf="node.capturedAt" nbPopover="Last Health Update
                      from the Device." nbPopoverTrigger="hover" nbPopoverPlacement="bottom">
                      Last Update: {{node.capturedAt | date:'medium' }}
                    </span>
                                    </div>
                                    <div>
                                        <span style="color: #0095ff; text-shadow: black;
                      font-weight: 500;" *ngIf="node.connectedTo> 0">
                      Connected To Node Id:{{node.connectedTo}}
                    </span>
                                    </div>
                                    <div class="hub-options">
                                        <!-- *ngIf="offlineNodes.includes(node.nodeId)" -->
                                        <nb-icon  icon="more-vertical-outline" [nbContextMenu]="nodeSpecificMenu" [nbContextMenuTag]="[node.shortAddress, hub.hubId,
                      customersData['emailId']?customersData['emailId']:customersData['mobile'],
                      customersData['_id'],node.nodeId,node,hub]"></nb-icon>
                                        <nb-icon mat-raised-button (click)="openNodeHistoryDialog(node.nodeId)" icon="clock-outline"></nb-icon>
                                    </div>
                                </div>

                                <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="32px" fxLayoutAlign="flex-start">

                                    <div class="hub-summary">
                                        <div> eID </div>
                                        <div class="h6">
                                            <span (click)="showToast(1000, 'copied', node.nodeId)" [cdkCopyToClipboard]="node.nodeId" nbPopover="Click to Copy" nbPopoverTrigger="hover" nbPopoverPlacement="bottom">
                        {{node.nodeId}}
                      </span>
                                        </div>
                                    </div>

                                    <div class="hub-summary">
                                        <div> Name </div>
                                        <div class="h6">{{node.nodeType}}</div>
                                    </div>

                                    <div class="hub-summary" *ngIf="node.createdAt">
                                        <div> Commissioned At </div>
                                        <div class="h6">{{node.createdAt | date:'medium'}}</div>
                                    </div>
                                    <div class="hub-summary" *ngIf="node.warrantyExpiryAt">
                                        <div> Warranty Expiry At</div>
                                        <div class="h6">
                                            {{node.warrantyExpiryAt}}
                                        </div>
                                    </div>
                                    <div class="hub-summary">
                                        <div> firmware Version </div>
                                        <div class="h6">{{node.firmwareVersion}}</div>
                                    </div>

                                    <div class="hub-summary">
                                        <div> Hardware Version </div>
                                        <div class="h6">{{node.productV}}</div>
                                    </div>

                                    <div class="hub-summary" *ngIf="node.subType != undefined">
                                        <div> Sub Type </div>
                                        <div class="h6">{{node.subType}}</div>
                                    </div>

                                    <div class="hub-summary">
                                        <div> FW Image ID </div>
                                        <div class="h6">{{node.imageId == undefined ? -1 : node.imageId}}</div>
                                    </div>

                                    <div class="hub-summary">
                                        <div> Range Mode</div>
                                        <div class="h6">{{node.rangeMode == undefined ? "N/A" : node.rangeMode}}</div>
                                        <div fxLayout="row" *ngIf="node.rangeMode" style="margin-top: 5px;" fxLayoutAlign="space-evenly">
                                            <button *ngIf="node.rangeMode == 'LONG_RANGE'" nbTooltip="Change Node Range to Short" nbButton size="tiny" (click)="changeNodeRange('02',node.shortAddress,hub.hubId)">Short</button>
                                            <button *ngIf="node.rangeMode == 'NORMAL_RANGE'" nbTooltip="Change Node Range to Long" nbButton size="tiny" (click)="changeNodeRange('01',node.shortAddress,hub.hubId)">Long</button>
                                        </div>
                                    </div>

                                    <div class="hub-summary">
                                        <div> Capability Version</div>
                                        <div class="h6">{{node.applicationCapability == undefined ? "" : node.applicationCapability}}</div>
                                    </div>

                                    <div class="hub-summary">
                                        <div> Voltage </div>
                                        <div class="h6">
                                            <nb-icon icon="activity-outline"></nb-icon>
                                            {{node.voltage?node.voltage.toFixed(3):"N/A"}}
                                        </div>
                                    </div>

                                    <div class="hub-summary">
                                        <div> Temperature </div>
                                        <div class="h6">
                                            <nb-icon icon="thermometer-outline"></nb-icon>
                                            {{node.temperature?node.temperature:"N/A"}}
                                        </div>
                                    </div>

                                    <div class="hub-summary">
                                        <div> RSSi </div>
                                        <div class="h6">
                                            <nb-icon icon="radio-outline" [status]="getRssiWarningLevel(node.rssi)"></nb-icon>
                                            {{node.rssi?node.rssi+110:"N/A"}}
                                        </div>
                                    </div>

                                    <div class="hub-summary" *ngIf="node.wifi_mac">
                                        <div> Wi-Fi MAC </div>
                                        <div class="h6">{{node.wifi_mac}}</div>
                                    </div>

                                    <ng-container *ngIf="node.mmcData">
                                        <div class="hub-summary">
                                            <div> SSID </div>
                                            <div class="h6">{{node.mmcData.ssid || "N/A"}}</div>
                                        </div>
                                        <div class="hub-summary">
                                            <div> Last Known IP </div>
                                            <div class="h6">{{node.mmcData.lastKnownIp || "N/A"}}</div>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="!hub.pDataAccessible">
                                        <div *ngFor="let app of node.apps">
                                            <div class="hub-summary">
                                                <div> {{app.appType}} </div>
                                                <div *ngIf="app.isOffline">
                                                    <nb-icon icon="globe" status="basic" nbPopover="Offline" nbPopoverTrigger="hover" nbPopoverPlacement="bottom"></nb-icon>
                                                </div>
                                                <div *ngIf="!app.isOffline">
                                                    <div *ngIf="!isNonTurnOffableDevice(app.appType)">
                                                        <nb-icon *ngIf="app.currentStatus>0" icon="globe" status="success" nbPopover="ON" nbPopoverTrigger="hover" nbPopoverPlacement="bottom"></nb-icon>
                                                        <nb-icon *ngIf="app.currentStatus<1" icon="globe" status="danger" nbPopover="OFF" nbPopoverTrigger="hover" nbPopoverPlacement="bottom"></nb-icon>
                                                        <span class="h6" *ngIf="app.currentStatus == null">N/A</span>
                                                    </div>
                                                    <div *ngIf="isNonTurnOffableDevice(app.appType)">
                                                        <nb-icon icon="globe" status="info" nbPopover="ON" nbPopoverTrigger="hover" nbPopoverPlacement="bottom"></nb-icon>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>

                                    <div *ngIf="hub.pDataAccessible">
                                        <div *ngFor="let app of node.apps">
                                            <div class="hub-summary">
                                                <div>{{getNodeName(hub.pData[hub.hubId + ':' + node.shortAddress + ':' + app.address + ":" + "P_NODE"])}} ({{app.appType}})
                                                </div>
                                                <div *ngIf="app.isOffline">
                                                    <nb-icon icon="globe" status="basic" nbPopover="Offline" nbPopoverTrigger="hover" nbPopoverPlacement="bottom"></nb-icon>
                                                </div>
                                                <div *ngIf="!app.isOffline">
                                                    <div *ngIf="!isNonTurnOffableDevice(app.appType)">
                                                        <nb-icon *ngIf="app.currentStatus>0" icon="globe" status="success" nbPopover="ON" nbPopoverTrigger="hover" nbPopoverPlacement="bottom"></nb-icon>
                                                        <nb-icon *ngIf="app.currentStatus<1" icon="globe" status="danger" nbPopover="OFF" nbPopoverTrigger="hover" nbPopoverPlacement="bottom"></nb-icon>
                                                        <span class="h6" *ngIf="app.currentStatus == null">N/A</span>
                                                    </div>
                                                    <div *ngIf="isNonTurnOffableDevice(app.appType)">
                                                        <nb-icon icon="globe" status="info" nbPopover="ON" nbPopoverTrigger="hover" nbPopoverPlacement="bottom"></nb-icon>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- sNodes inside Node -->
                                    <nb-accordion class="info-section" style="width: 100%;">
                                            <nb-accordion-item *ngIf="node.sNodes && node.sNodes.length">
                                                <nb-accordion-item-header class="no-arrow" (click)="ngAccordingHeaderClickedForNode($event,'showVNs',hub,node)">
                                                    <div fxLaout="row" style="width: 100%;" fxLayoutAlign="space-between center">
                                                        <b style="display: inline;">Virtual Nodes</b>
                                                        <!-- <nb-toggle class="custom-toggle checked" labelPosition="start" [(checked)]="hub.showVNs" style="z-index: 999;"></nb-toggle> -->
                                                    </div>
                                                </nb-accordion-item-header>
                                                <nb-accordion-item-body *ngIf="node.showVNs">
                                                    <div fxLayout="row" fxLayoutAlign="end center" style="margin-bottom: 20px;">
                                                        <nb-toggle labelPosition="start" [(checked)]="showDeletedSNodes" (change)="onShowSNodeToggle()">Show Deleted Devices Also</nb-toggle>
                                                    </div>
                                                    <!-- added filter pipe for searching nodes -->
                                                    <nb-card *ngFor="let sNode of node['sNodes']" class="summary-infoCard">
                                                        <nb-card-body id="{{hub.hubId + ':' + sNode.sNodeId}}">
                                                            <div class="node-header">
                                                                <div>
                                                                    <span class="subtitle">Virtual Node Id: {{sNode.sNodeId}}
                                                                    </span>
                                                                </div>
                                                                <div>
                                                                    <span *ngIf="sNode.capturedAt" nbPopover="Last Status Update
                                                                    from the Device." nbPopoverTrigger="hover" nbPopoverPlacement="bottom">
                                                                    Last Update: {{sNode.capturedAt | date:'medium' }}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="32px" fxLayoutAlign="flex-start">

                                                                <div class="hub-summary">
                                                                    <div> Name </div>
                                                                    <div class="h6">{{sNode.sFeatureType}} | {{sNode.sFeatureDeviceType}} {{sNode.pName == undefined ? "" : " | "+sNode.pName}}</div>
                                                                </div>

                                                                <div class="hub-summary">
                                                                    <div> State </div>
                                                                    <div class="h6">{{sNode.sNodeState}}</div>
                                                                </div>

                                                                <div class="hub-summary" *ngIf="sNode.createdAt">
                                                                    <div> Created At </div>
                                                                    <div class="h6">{{sNode.createdAt | date:'medium'}}</div>
                                                                </div>
                                                            
                                                                <div class="hub-summary">
                                                                    <div> Capability Version</div>
                                                                    <div class="h6">{{sNode.applicationCapability == undefined ? "" : sNode.applicationCapability}}</div>
                                                                </div>
                                                            </div>

                                                            <ng-container>
                                                                <div *ngFor="let app of sNode.sAppsV2">
                                                                    <div class="hub-summary">
                                                                        <div> App ID : <b>{{app.sAppId}}</b> </div>
                                                                        <div *ngIf="app.isOffline">
                                                                            <nb-icon icon="globe" status="basic" nbPopover="Offline" nbPopoverTrigger="hover" nbPopoverPlacement="bottom"></nb-icon>
                                                                        </div>
                                                                        <div *ngIf="app.action != undefined">
                                                                            <div>
                                                                                <nb-icon *ngIf="app.action == 'ON'" icon="globe" status="success" nbPopover="ON" nbPopoverTrigger="hover" nbPopoverPlacement="bottom"></nb-icon>
                                                                                <nb-icon *ngIf="app.action == 'OFF'" icon="globe" status="danger" nbPopover="OFF" nbPopoverTrigger="hover" nbPopoverPlacement="bottom"></nb-icon>
                                                                            </div>
                                                                        </div>
                                                                        <div>
                                                                            <b>Physical Node ID {{node.shortAddress}}'s Devices : ({{getAssociationCount(app.associationsV2)}})</b>
                                                                            <br>
                                                                            <br>
                                                                            <span *ngFor="let association of app.associationsV2">
                                                                                <b class="hub-summary" *ngFor="let appId of association.nodeAppIds; index as i" style="margin-right: 3px;">
                                                                                    ({{association.nodeShortId}},{{appId}})
                                                                                </b>
                                                                            </span>
                                                                            <br>
                                                                            <br>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </ng-container>

                                                        </nb-card-body>
                                                    </nb-card>


                                                    <!-- <nb-layout *ngFor="let node of hub['nodes']">
                                                        <nb-layout-column class="colored-column-warning">eID <br> Name <br> Commissioned At <br> firmware
                                                            Version

                                                            <br> SSID <br> WiFi Mac
                                                            <br> Last Known IP <br> Last Known Port
                                                            <br> FW Version <br>
                                                        </nb-layout-column>
                                                        <nb-layout-column> {{node.nodeId}} <br> {{node.nodeType}} <br> {{node.createdAt}} <br>
                                                            {{node.firmwareVersion}}
                                                        </nb-layout-column>
                                                    </nb-layout> -->
                                                </nb-accordion-item-body>
                                            </nb-accordion-item>
                                    </nb-accordion>

                                </div>

                            </nb-card-body>
                            <nb-card-body>
                                <div fxLayout="row">
                                    <nb-card style="width: 100%;">
                                        <nb-card-body>
                                            <div fxLayout="row" fxLayoutAlign="space-evenly center">
                                                <b>Health Graph :</b>
                                                <input [nbDatepicker]="datepickerNodeStart" nbInput placeholder="Start Date" [(ngModel)]="node.graphStart">
                                                <nb-datepicker #datepickerNodeStart></nb-datepicker>
                                                <b>-</b>
                                                <input [nbDatepicker]="datepickerNodeEnd" nbInput placeholder="End Date" [(ngModel)]="node.graphEnd">
                                                <nb-datepicker #datepickerNodeEnd></nb-datepicker>
                                                <nb-checkbox style="margin-left: 20px;" (checkedChange)="showAllHealthDataChangeNode($event,node)">Show All Points</nb-checkbox>
                                                <button nbButton status="info" (click)="fetchHealthGraph(node.nodeId,
                                            node.nodeType, node.showHealthGraph,node.showAllHealthData,node)">Get Health Data</button>
                                            </div>
                                            <plotly-plot style="width: 100%;" *ngIf="graph[node.nodeId] && node.showHealthGraph" [data]="graph[node.nodeId].data" [layout]="graph[node.nodeId].layout"></plotly-plot>
                                        </nb-card-body>
                                    </nb-card>
                                </div>
                            </nb-card-body>
                            <nb-card-body *ngIf="node.nodeType.includes('TR_EP') && node.accessoryInfo">
                                <nb-accordion>
                                    <nb-accordion-item>
                                        <nb-accordion-item-header>Accessory Information</nb-accordion-item-header>
                                        <nb-accordion-item-body>
                                            <span>Accessory ID :  </span> <b>{{node.accessoryInfo.aId}}</b> <br>
                                            <span>Style :  </span> <b>{{node.accessoryInfo.style}}</b> <br>
                                            <span>Batch No :  </span> <b>{{node.accessoryInfo.batchNo}}</b> <br>
                                            <span>Generated By :  </span> <b>{{node.accessoryInfo.generatedBy}}</b> <br>
                                            <span>Style Updated By :  </span> <b>{{node.accessoryInfo.styleUpdatedBy}}</b> <br>
                                            <span>Associated By :  </span> <b>{{node.accessoryInfo.associatedBy}}</b> <br>
                                            <span>Associated At :  </span> <b>{{getHumanReadableTime(node.accessoryInfo.associatedAt)}}</b> <br>
                                            <span>Warranty Expiry At :  </span> <b>{{getTouchWarrantyTime(node.accessoryInfo.associatedAt)}}</b> <br>

                                        </nb-accordion-item-body>
                                    </nb-accordion-item>
                                </nb-accordion>
                            </nb-card-body>
                        </nb-card>


                        <!-- <nb-layout *ngFor="let node of hub['nodes']">
              <nb-layout-column class="colored-column-warning">eID <br> Name <br> Commissioned At <br> firmware
                Version

                <br> SSID <br> WiFi Mac
                <br> Last Known IP <br> Last Known Port
                <br> FW Version <br>
              </nb-layout-column>
              <nb-layout-column> {{node.nodeId}} <br> {{node.nodeType}} <br> {{node.createdAt}} <br>
                {{node.firmwareVersion}}
              </nb-layout-column>
            </nb-layout> -->
                    </nb-accordion-item-body>
                </nb-accordion-item>
            </nb-accordion>
            <nb-accordion class="info-section">
                <nb-accordion-item *ngIf="hub.sNodes && hub.sNodes.length">
                    <nb-accordion-item-header class="no-arrow" (click)="ngAccordingHeaderClicked($event,'showVNs',hub)">
                        <div fxLaout="row" style="width: 100%;" fxLayoutAlign="space-between center">
                            <b style="display: inline;">Virtual Nodes</b>
                            <!-- <nb-toggle class="custom-toggle checked" labelPosition="start" [(checked)]="hub.showVNs" style="z-index: 999;"></nb-toggle> -->
                        </div>
                    </nb-accordion-item-header>
                    <nb-accordion-item-body *ngIf="hub.showVNs">
                        <div fxLayout="row" fxLayoutAlign="end center" style="margin-bottom: 20px;">
                            <nb-toggle labelPosition="start" [(checked)]="showDeletedSNodes" (change)="onShowSNodeToggle()">Show Deleted Devices Also</nb-toggle>
                        </div>
                        <!-- added filter pipe for searching nodes -->
                        <nb-card *ngFor="let sNode of hub['sNodes']" class="summary-infoCard">
                            <nb-card-body #node id="{{hub.hubId + ':' + sNode.sNodeId}}">
                                <div class="node-header">
                                    <div>
                                        <span class="subtitle">Virtual Node Id: {{sNode.sNodeId}}
                                        </span>
                                    </div>
                                    <div>
                                        <span *ngIf="sNode.capturedAt" nbPopover="Last Status Update
                                        from the Device." nbPopoverTrigger="hover" nbPopoverPlacement="bottom">
                                        Last Update: {{sNode.capturedAt | date:'medium' }}
                                        </span>
                                    </div>
                                </div>

                                <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="32px" fxLayoutAlign="flex-start">

                                    <div class="hub-summary">
                                        <div> Name </div>
                                        <div class="h6">{{sNode.sFeatureType}} | {{sNode.sFeatureDeviceType}} {{sNode.pName == undefined ? "" : " | "+sNode.pName}}</div>
                                    </div>

                                    <div class="hub-summary">
                                        <div> State </div>
                                        <div class="h6">{{sNode.sNodeState}}</div>
                                    </div>

                                    <div class="hub-summary" *ngIf="sNode.createdAt">
                                        <div> Created At </div>
                                        <div class="h6">{{sNode.createdAt | date:'medium'}}</div>
                                    </div>
                                
                                    <div class="hub-summary">
                                        <div> Capability Version</div>
                                        <div class="h6">{{sNode.applicationCapability == undefined ? "" : sNode.applicationCapability}}</div>
                                    </div>
                                </div>

                                <ng-container>
                                    <div *ngFor="let app of sNode.sApps">
                                        <div class="hub-summary">
                                            <div> App ID : <b>{{app.sAppId}}</b> </div>
                                            <div *ngIf="app.isOffline">
                                                <nb-icon icon="globe" status="basic" nbPopover="Offline" nbPopoverTrigger="hover" nbPopoverPlacement="bottom"></nb-icon>
                                            </div>
                                            <div *ngIf="app.action != undefined">
                                                <div>
                                                    <nb-icon *ngIf="app.action == 'ON'" icon="globe" status="success" nbPopover="ON" nbPopoverTrigger="hover" nbPopoverPlacement="bottom"></nb-icon>
                                                    <nb-icon *ngIf="app.action == 'OFF'" icon="globe" status="danger" nbPopover="OFF" nbPopoverTrigger="hover" nbPopoverPlacement="bottom"></nb-icon>
                                                </div>
                                                <!-- <div *ngIf="isNonTurnOffableDevice(app.appType)">
                                                    <nb-icon icon="globe" status="info" nbPopover="ON" nbPopoverTrigger="hover" nbPopoverPlacement="bottom"></nb-icon>
                                                </div> -->
                                            </div>
                                            <div>
                                                <b>Physical Devices : ({{getAssociationCount(app.associations)}})</b>
                                                <br>
                                                <br>
                                                <span *ngFor="let association of app.associations">
                                                    <b class="hub-summary" *ngFor="let appId of association.nodeAppIds; index as i" style="margin-right: 3px;">
                                                        ({{association.nodeShortId}},{{appId}})
                                                    </b>
                                                </span>
                                                <br>
                                                <br>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                            </nb-card-body>
                        </nb-card>


                        <!-- <nb-layout *ngFor="let node of hub['nodes']">
                            <nb-layout-column class="colored-column-warning">eID <br> Name <br> Commissioned At <br> firmware
                                Version

                                <br> SSID <br> WiFi Mac
                                <br> Last Known IP <br> Last Known Port
                                <br> FW Version <br>
                            </nb-layout-column>
                            <nb-layout-column> {{node.nodeId}} <br> {{node.nodeType}} <br> {{node.createdAt}} <br>
                                {{node.firmwareVersion}}
                            </nb-layout-column>
                        </nb-layout> -->
                    </nb-accordion-item-body>
                </nb-accordion-item>
            </nb-accordion>
            <nb-accordion class="info-section">
                <nb-accordion-item>
                    <nb-accordion-item-header>Access List</nb-accordion-item-header>
                    <nb-accordion-item-body>
                        <nb-card class="inline-form-card">
                            <nb-card-body>
                                <div fxLayout="column" style="width: 100%;" *ngIf="hub.finalAcls == undefined || hub.finalAcls.length < 0">
                                    <button nbButton [disabled]="isFetchingAccessList" fullWidth status="primary" (click)="fetchAccessList(hub.hubId,hub)">Fetch Access List</button>
                                </div>
                                <div fxLayout="row wrap" fxLayout.lt-sm="column"
                                    fxLayoutAlign="flex-start"
                                    *ngIf="hub.finalAcls && hub.finalAcls.length > 0"
                                    style="margin-top: 20px;margin-bottom: 30px;">
                                    <div style="margin: 20px;min-width: 270px;" *ngFor="let item of hub.finalAcls">
                                        <mat-card 
                                            fxFlex.lt-sm="100%" class="mat-elevation-z8">
                                            <a [routerLink]="['/user', item._id]" [state]="{ data: item}" target="_blank"
                                                style="text-decoration: none;">
                                                <mat-card-content>
                                                    <nb-user size="large" name="{{item['fullName']}}"
                                                        title="{{item['emailId']?item['emailId']:item['mobile']}}"
                                                        [picture]="item['profilePicUrl']" color="#ffc94d"
                                                        showInitials="true" badgeText="{{item['accessType']}}"
                                                        badgeStatus="{{item['accessType'] == 'FA' ? 'success' : 'danger'}}"
                                                        badgePosition="bottom right">
                                                    </nb-user>
                                                </mat-card-content>
                                            </a>
                                        </mat-card>
                                    </div>
                                </div>
                            </nb-card-body>
                        </nb-card>
                    </nb-accordion-item-body>
                </nb-accordion-item>
            </nb-accordion>
            <nb-accordion class="info-section">
                <!-- <nb-accordion-item (collapsedChange)="fetchCriticalLogs(hub.hubId, 10, 0, i)" #debuggerAccordian>
                    <nb-accordion-item-header>Critical Logs</nb-accordion-item-header>
                    <nb-accordion-item-body>
                        <mat-list *ngIf="hub.criticalLogs">
                        <mat-list-item *ngFor="let log of hub.criticalLogs">
                            <span style="padding-left: 2%">{{log['capturedAt'] | date:'medium' }}</span>
                            <span style="padding-left: 2%"> </span>
                            <span style="padding-left: 2%">{{criticalLogMsg(log)}}</span>
                        </mat-list-item>
                        </mat-list>
                        <mat-paginator [length]="hub.criticalLogsSize" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"
                        (page)="fetchCriticalLogs(hub.hubId, $event.pageSize, $event.pageIndex, i)">
                        </mat-paginator>
                    </nb-accordion-item-body>
                </nb-accordion-item> -->
                <nb-accordion-item #debuggerAccordian>
                    <nb-accordion-item-header>Critical Logs</nb-accordion-item-header>
                    <nb-accordion-item-body>
                        <div class="summary-container">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <input nbInput placeholder="Pick Date"
                                [nbDatepicker]="dateTimePicker" [(ngModel)]="today">
                                <nb-datepicker #dateTimePicker></nb-datepicker>
                                <button nbButton ghost status="primary"
                                (click)="fetchCriticalLogs(hub.hubId, 10, 0, i, hub.placeId,
                                today)">
                                <nb-icon icon="sync-outline"></nb-icon>
                                </button>

                                <div class="hub-summary" fxLayout="row" fxLayoutAlign="start center">
                                    <nb-toggle status="primary" [(ngModel)]="hub.autoRefreshLogs" (checkedChange)="autoRefreshLogsToggleChanged(hub,i)">Auto Refresh</nb-toggle>
                                    <span style="margin-left: 10px;margin-right: 10px;" *ngIf="hub.autoRefreshLogs">in</span>
                                    <nb-select [(selected)]="hub.autoRefreshLogsTime" *ngIf="hub.autoRefreshLogs" (selectedChange)="autoRefreshLogsTimeChanged(hub,i)">
                                        <nb-option value="15">15s</nb-option>
                                        <nb-option value="20">20s</nb-option>
                                    </nb-select>
                                </div>
                            </div>
                        </div>
                        <mat-list *ngIf="hub.criticalLogs && hub.criticalLogs.length>0">
                            <h6 style="padding-left: 2%">({{hub.startDate| date:'longDate'}} - {{hub.endDate| date:'longDate'}})</h6>
                            <mat-list-item *ngFor="let log of hub.criticalLogs | paginate: { itemsPerPage:
                20, currentPage: hub.currentPage }">
                                <span style="padding-left: 2%" nbTooltip="{{log['capturedAt']}}" nbTooltipStatus="primary">{{log['capturedAt'] |
                  date:'medium' }}</span>
                                <span style="padding-left: 2%"> </span>
                                <span style="padding-left: 2%">{{criticalLogMsg(log)}}</span>
                            </mat-list-item>
                        </mat-list>
                        <pagination-controls (pageChange)="hub.currentPage= $event"></pagination-controls>
                    </nb-accordion-item-body>
                </nb-accordion-item>
            </nb-accordion>
            <nb-accordion class="info-section">
                <nb-accordion-item *ngIf="hub['geo']">
                    <nb-accordion-item-header class="no-arrow" (click)="ngAccordingHeaderClicked($event,'showLocation',hub)">
                        <div fxLaout="row" style="width: 100%;" fxLayoutAlign="space-between center">
                            <b style="display: inline;">Location</b>
                            <!-- <nb-toggle class="custom-toggle checked" labelPosition="start" [(checked)]="hub.showLocation" style="z-index: 999;"></nb-toggle> -->
                        </div>
                    </nb-accordion-item-header>
                    <nb-accordion-item-body *ngIf="hub.showLocation">
                        <google-map [center]="position" [zoom]="4" width="100%" height="36.5625rem">
                            <map-marker [position]="{ lat: hub['geo']['x'], lng:
                hub['geo']['y'] }" [options]="markerOptions">
                            </map-marker>
                        </google-map>
                    </nb-accordion-item-body>
                </nb-accordion-item>
            </nb-accordion>
        </nb-card-body>
    </nb-card>
</div>

<div fxLayout="column" style="margin-top: 20px;" *ngIf="linkedDevices.yale.length" id="linkedDevicesSection">
    <h6>Linked Devices :</h6>

    <nb-accordion>
        <nb-accordion-item *ngFor="let device of linkedDevices.yale" style="margin-top: 10px;">
            <nb-accordion-item-header>
            <div class="flex justify-between items-center w-full">
                <div fxLayout="column" fxLayoutAlign="start start">
                                    <span class="font-bold">{{ device.name }}</span>
                                    <span class="lock-id-tag">{{formatLockId(device.userId.toUpperCase())}}</span>
                </div>
                <nb-badge *ngIf="device.isFav" text="Fav" status="success"></nb-badge>
            </div>
            </nb-accordion-item-header>

            <nb-accordion-item-body>
            <nb-card style="margin-top: 10px;">
                <nb-card-body>
                <!-- device info -->
                <div class="device-info-grid">
                    <div class="info-item">
                        <strong>User ID:</strong>
                        <span>{{ device.userId || "N/A" }}</span>
                    </div>
                    <div class="info-item">
                    <strong>Email:</strong>
                    <span>{{ device.email || "N/A" }}</span>
                    </div>
                    <div class="info-item">
                    <strong>Phone:</strong>
                    <span>{{ device.phoneNumber || "N/A" }}</span>
                    </div>
                    <div class="info-item">
                    <strong>Country:</strong>
                    <span>{{ device.country || "N/A" }}</span>
                    </div>
                    <div class="info-item">
                    <strong>Space ID:</strong>
                    <span>{{ device.roomId.includes("default::") ? "Default Space" : device.roomId }}</span>
                    </div>
                    <div class="info-item">
                    <strong>Created:</strong>
                    <span>{{ device.createdAt | date:'dd MMM, yyyy hh:mm a' }}</span>
                    </div>
                    <div class="info-item">
                    <strong>Updated:</strong>
                    <span>{{ device.updatedAt | date:'dd MMM, yyyy hh:mm a' }}</span>
                    </div>
                </div>

                <!-- locks accordion -->
                
                    <div *ngFor="let lock of device.locks" style="margin-top: 20px;">
                        <nb-accordion>
                            <nb-accordion-item >
                        <nb-accordion-item-header>
                            <div class="flex justify-between w-full">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <div fxLayout="column" fxLayoutAlign="start start">
                                    <span>{{ lock.lockName }}</span>
                                    <span class="lock-id-tag">{{formatLockId(lock.lockId)}}</span>
                                </div>
                                <nb-icon style="margin-left: 5px"
                                    [icon]="lock.isOffline ? 'close-circle-outline' : 'checkmark-circle-2-outline'" 
                                    [status]="lock.isOffline ? 'danger' : 'success'">
                                </nb-icon>
                            </div>
                            <nb-badge 
                                [text]="lock.lockStatus.toUpperCase()" 
                                [status]="lock.lockStatus === 'locked' ? 'success' : 'danger'">
                            </nb-badge>
                            </div>
                        </nb-accordion-item-header>
                        <nb-accordion-item-body>
                            <div class="lock-info-grid">
                                <div class="info-item">
                                    <strong>Lock ID:</strong>
                                    <span>{{ lock.lockId || "N/A" }}</span>
                                </div>
                                <div class="info-item">
                                    <strong>Serial Number:</strong>
                                    <span>{{ lock.serialNumber || "N/A" }}</span>
                                </div>
                                <div class="info-item">
                                    <strong>Bridge ID:</strong>
                                    <span>{{ lock.bridgeID || "N/A" }}</span>
                                </div>
                            <div class="info-item">
                                <strong>Type:</strong>
                                <span>{{ lock.lockType }}</span>
                            </div>
                            <div class="info-item">
                                <strong>Space ID:</strong>
                                <span>{{ lock.roomId.includes("default::") ? "Default Space" : lock.roomId }}</span>
                            </div>
                            <div class="info-item">
                                <strong>Online:</strong>
                                <nb-icon 
                                [icon]="lock.isOffline ? 'close-circle-outline' : 'checkmark-circle-2-outline'" 
                                [status]="lock.isOffline ? 'danger' : 'success'">
                                </nb-icon>
                            </div>
                            <div class="info-item">
                                <strong>Battery:</strong>
                                <span>{{ lock.batteryInfo }}</span>
                            </div>
                            <div class="info-item">
                                <strong>Created:</strong>
                                <span>{{ lock.createdAt | date:'dd MMM, yyyy hh:mm a' }}</span>
                            </div>
                            <div class="info-item">
                                <strong>Updated:</strong>
                                <span>{{ lock.updatedAt | date:'dd MMM, yyyy hh:mm a' }}</span>
                            </div>
                            </div>
                        </nb-accordion-item-body>
                        </nb-accordion-item>
                        </nb-accordion>
                    </div>
                </nb-card-body>
            </nb-card>
            </nb-accordion-item-body>
        </nb-accordion-item>
    </nb-accordion>
</div>
